import React, { useState } from 'react'
import {
  ApplicationColumn,
  FormIdeaInnerDiv,
  FormIdeaOuterDiv,
  TitleContainer,
  TitleText,
  TabsContainer,
  TabItem,
  ContentContainer,
  ButtonWrapper
} from './styles'
import {
  FormIdeaSections
} from '../styles'
import { IdeaEvaluation } from '../IdeaEvaluation'
import { DownloadPdfButton } from '../PdfButton'

export interface FormIdeaDesktopProps {
  solutionTitle: string
  setIsNavigationBlocked: Function
  resolverId: string
  challengeId: string
  solutionId: string
  evaluation: any
  formIdeaSectionsBody: JSX.Element
  stepName?: string
}
export const FormIdeaDesktop = ({ solutionTitle, setIsNavigationBlocked, resolverId, challengeId, solutionId, evaluation, formIdeaSectionsBody, stepName }: FormIdeaDesktopProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState('inscricoes')

  return (
    <FormIdeaOuterDiv>
      <ApplicationColumn>
        <TitleContainer>
          <TitleText>{solutionTitle}</TitleText>
          <ButtonWrapper>
            <DownloadPdfButton
              challengeId={challengeId}
              solutionId={solutionId}
              solutionTitle={solutionTitle}
            />
          </ButtonWrapper>
        </TitleContainer>

        <TabsContainer>
          <TabItem
            className={activeTab === 'inscricoes' ? 'active' : ''}
            onClick={() => setActiveTab('inscricoes')}
          >
            Inscrições
          </TabItem>
          <TabItem
            className={activeTab === 'anexos' ? 'active' : ''}
            onClick={() => setActiveTab('anexos')}
          >
            Anexos
          </TabItem>
        </TabsContainer>

        <ContentContainer>
          <FormIdeaInnerDiv>
            <FormIdeaSections id='FormIdeaSections'>
              {activeTab === 'inscricoes' && formIdeaSectionsBody}
              {activeTab === 'anexos' && (
                <div className='mt-2'>
                  <p>Nenhum anexo disponível</p>
                </div>
              )}
            </FormIdeaSections>
          </FormIdeaInnerDiv>
        </ContentContainer>
      </ApplicationColumn>

      <IdeaEvaluation
        evaluation={evaluation}
        resolverId={resolverId}
        setIsNavigationBlocked={setIsNavigationBlocked}
        stepName={stepName}
      />
    </FormIdeaOuterDiv>
  )
}
